import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { Menu, Spin } from 'antd'

export const BreadLastData = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: #000;
`
export const LeftBread = styled.div`
  color: #000;
  font-size: 16px;
  font-weight: 600;
  margin-left: 2.1rem;
  margin-top: 0.5rem;
`
export const StyledH2 = styled.h2`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 120%;
  padding-top: 10px;
  margin-left: 9px;
`
export const Cirlcle = styled.div`
  width: 6px;
  height: 6px;
  background: #4d566e;
  border-radius: 50% !important;
  margin-right: 9px;
`

export const StyledP = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #4d566e;
  padding-top: 5px;
  line-height: initial;
`
export const AlertFlex = styled(Flex)`
  background: ${COLORS.BLUR_T_90};
  border: 1px solid ${COLORS.BLUR_T_95};
  border-radius: 10px;
  padding: 10px;
  margin: 15px 0;
  gap: 12px;
`
export const TextWrapper = styled(Flex)`
  padding-left: 12px;
  margin-bottom: 5px;
`
export const SubTextWrapper = styled(Flex)`
  padding-left: 20px;
  line-height: initial;
  align-items: baseline;
`
export const ResultWrapper = styled(Flex)`
  line-height: initial;
  align-items: center;
`
export const TableCount = styled.div`
  display: flex;
  width: max-content;
  margin: auto;
  color: #323538;
`
export const SearchWidth = styled.div`
  width: 62.3%;
  border-right: 1px solid #dfdfdf;
  
`

export const StyledButton1 = styled.button`
  width: 89px;
  height: 38px;

  gap: 0px;
  border-radius: 22px 22px;
  border: none;
  cursor: pointer;

  background-color: ${props => (props.isSelected ? '#3249D7' : '#FFFFFF')};
  color: ${props => (props.isSelected ? 'white' : '#3249D7')};
  border: 1px solid #3249d7;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
`
export const NoteMessageDivNew = styled(Flex)`
  line-height: 1rem;
  height: 40px;
  border: #d6dbf7 solid 2px;
  background-color: ${props => (props.mandatory ? '#3249d7' : 'white')};
  border-radius: 15px;
  justify-content: left;
  margin-bottom: 20px;
  transition: background-color 0.3s;
  color: ${props => (props.mandatory ? 'white' : '#3249d7')};
  display: inline-flex;
`
export const StyledSpaceDiv = styled.div`
  display: flex;
  gap: 4px;
  margin-left: 4px;
  align-items: center;
`

export const AlertTextDivNew = styled.div`
  font-size: 0.8em;
  color: ${props => (props.mandatory ? 'white' : '#3249d7')};
  margin-left: 4px;
  margin-right: 4px;
  font-weight: 600;
  margin-left: 4px;
  display: flex;
`
export const EmptyElement = styled('div')`
  width: 100%;
`

export const CustomizeMenu = styled(Menu)`
  .ant-dropdown-menu-item {
    font-weight: 700;
  }
  .ant-dropdown-menu-title-content {
    width: max-content;
  }
`

export const CustomSpin = styled(Spin)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
`

export const RightSideDiv = styled.div`
  display: flex;
  height: 50px;
  gap: 15px;
`

export const CustomDiv = styled.div`
  cursor: pointer;
`
